import { render, staticRenderFns } from "./PageToolbar.vue?vue&type=template&id=9b6064c2&"
import script from "./PageToolbar.vue?vue&type=script&lang=js&"
export * from "./PageToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports